import URI from "urijs";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
const urlPrefix = "/plugins/org.graylog.plugins.auditlog";
export const AUDIT_LOG_STATUS_QUERY_KEY = ["auditlog", "status"];
export const AUDIT_LOG_ENTRIES_QUERY_KEY = ["auditlog", "entries"];
export const getAuditLogExportURL = (format, query) => {
  const q = query ? `&query=${query}` : "";
  return new URI(qualifyUrl(`${urlPrefix}/entries/export/${format}?limit=10000${q}`)).toString();
};
const fetchAuditLogStatus = () => fetch("GET", qualifyUrl(`${urlPrefix}/status/all`)).catch((error) => {
  UserNotification.error(
    `Fetching audit log status failed with status: ${error.message}`,
    "Could not retrieve audit log status"
  );
  throw error;
});
const fetchAuditLogEntries = ({ page, perPage, query }) => {
  const promise = query ? fetch("POST", qualifyUrl(`${urlPrefix}/entries`), { page, per_page: perPage, query }) : fetch("GET", qualifyUrl(`${urlPrefix}/entries?page=${page}&per_page=${perPage}`));
  return promise.catch((error) => {
    UserNotification.error(
      `Fetching audit log entries failed with status: ${error.message}`,
      "Could not retrieve audit log entries"
    );
    throw error;
  });
};
export const useAuditLogStatus = () => useQuery({
  queryKey: AUDIT_LOG_STATUS_QUERY_KEY,
  queryFn: fetchAuditLogStatus,
  retry: false
});
export const useAuditLogEntries = (searchParams) => useQuery({
  queryKey: [...AUDIT_LOG_ENTRIES_QUERY_KEY, searchParams],
  queryFn: () => fetchAuditLogEntries(searchParams),
  placeholderData: keepPreviousData,
  retry: false
});
